import { render, staticRenderFns } from "./bindSet.vue?vue&type=template&id=aa48a754&scoped=true&"
import script from "./bindSet.vue?vue&type=script&lang=js&"
export * from "./bindSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa48a754",
  null
  
)

export default component.exports